import LoaderSpin from '@/components/snippets/loader-spin/loader-spin'
import { PageHeader } from './AccountSectionWrapper'
import { Suspense } from './Suspense'

/**
 * @typedef {import("../types/page.ts").AccountPageProps} AccountPageProps
 * @typedef {import("../types/page.ts").SuspenseProps} SuspenseProps
 * @typedef {import("../types/page.ts").AccountPageBodyProps} AccountPageBodyProps
 * @typedef {import("../types/page.ts").AccountPageSection} AccountPageSection
 * @typedef {import("../types/page.ts").BackPagePaths} BackPagePaths
 */

/**
 *
 * @param {AccountPageBodyProps} props
 * @returns
 */
const PageBody = ({ children, suspenseProps }) => {
  if (!suspenseProps) return { children }
  return (
    <Suspense
      refetch={suspenseProps?.refetch ?? 0}
      loadingState={suspenseProps?.loadingState}
      props={{
        asyncCallback: suspenseProps.asyncCallback
      }}
    >
      {children}
    </Suspense>
  )
}

/**
 *
 * @param {AccountPageSection} param0
 * @returns
 */
export const PageSection = ({ children, className }) => {
  if (!className) return { children }
  return <div className={className}>{children}</div>
}

/**
 *
 * @param {{path: BackPagePaths}} param0
 * @returns
 */
const PageBack = ({ path }) => {
  const { handlePushState } = useAccountLayoutContext()
  const handleBack = () => {
    handlePushState(path, true)
  }
  return (
    <div onClick={handleBack} className={'flex flex-row gap-2'}>
      <Icon id="arrow-left" />
      <div className={'btn btn-text btn-inline underline underline-offset-2'}>Back</div>
    </div>
  )
}

/**
 *
 * @param {AccountPageProps} param0
 * @returns
 */
export const Page = ({ props, children }) => {
  return (
    <div className={'flex flex-col gap-8 md:gap-10'}>
      {props?.page?.backPath && <PageBack path={props.page.backPath} />}
      {props?.page?.title ? <PageHeader title={props?.page?.title ?? ''} cta={props?.page?.cta} /> : <></>}
      <PageBody suspenseProps={props?.suspense}>{children}</PageBody>
    </div>
  )
}

/**
 * @param {boolean} isActive - Whether the form is in a busy state
 * @param {boolean} isDisabled - Will disable the save button if true
 */
export const Form = ({ onSubmit, className, isActive, children, buttonText, isDisabled = false, hasChanged = true }) => {
  return (
    <form
      onSubmit={onSubmit}
      className={`flex flex-col gap-4 transition-opacity ${isActive ? 'opacity-45' : ''} ${className ?? ''}`}
    >
      {children}
      <div>
        <button disabled={isDisabled || !hasChanged} className={'btn btn-md btn-solid-black relative min-w-24 overflow-hidden'}>
          {isActive ? <LoaderSpin wrapperClass="bg-black" /> : buttonText ?? 'Save'}
        </button>
      </div>
    </form>
  )
}
